import { EntityState } from '@ngrx/entity';

export interface IResidentProfileCommon {
  profileId: number;
  title: string | null;
  firstName: string;
  lastLoggedIn: Date;
  lastName: string;
  email: string;
  displayName: string;
  mobilePhone: string | null;
  phone: string | null;
  unitId: number;
  profilePictureUrl: string | null;
  roleId: number;
  facebookProfile: string | null;
  twitterHandle: string | null;
  instagramProfile: string | null;
  receiveNotificationSms: boolean | null;
  receiveNotificationEmail: boolean | null;
  consolidatedProfiles: IConsolidatedProfile[];
}

export interface IConsolidatedProfile {
  profileId: number;
  unitId: number;
  strataPlanNumber: string;
  lotNumber: string;
  unitNumber: string;
}

export interface IResidentProfileTable
  extends EntityState<IResidentProfileCommon> {
  selectedProfileId: number;
  selectedRoleId: number;
}

export function selectProfileId(a: IResidentProfileCommon): number {
  return a.profileId;
}
